import type { DtsInboundApiDto } from '@dhl/mdp-api'
import { presentDateOrDefault } from '~/modules/ppp/submodules/relations/utils'
import { DataRow, DataHeading } from '~/modules/ppp/submodules/relations/components/data'

type Props = {
  config: DtsInboundApiDto
}
export const InboundApi = ({ config }: Props) => (
  <>
    <DataHeading title="API" />
    <DataRow title="createdOn" payload={presentDateOrDefault(config.createdOn)} />
    <DataRow title="inName" payload={config.inName} withCopy />
    <DataRow title="inboundApi/cdex/systemId" payload={config.inboundApiSettings.cdex?.systemId} withCopy />
    <DataRow title="inboundApi/cdex/users " payload={config.inboundApiSettings.cdex?.users?.join(',')} withCopy />
    <DataRow title="inboundConnectors" payload={config.inboundApiConnectors?.join(',')} withCopy />
  </>
)
